export default [
    {
        path: '/warehouse/borrow-request',
        name: 'borrow-request',
        props: true,
        component: () => import('@/views/warehouse/borrow-request/index.vue'),
        meta: {
            pageTitle: 'Borrow Request',
            breadcrumb: [
                {
                text: 'Borrow Request',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/borrow-request/:id',
        name: 'detail-borrow-request',
        props: true,
        component: () => import('@/views/warehouse/borrow-request/detail.vue'),
        meta: {
            pageTitle: 'Detail Borrow Request',
            breadcrumb: [
                {
                text: 'Borrow Request',
                to: { name: 'borrow-request' },
                },
                {
                text: 'Detail Borrow Request',
                active: true,
                },
            ],
        },
    },
]